export default __webpack_public_path__ + "static/media/Isometric-Tokenomics.eaf6a9c8.png";